<template>
  <div>
    <a-drawer :width="880" :closable="false" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="close">
      <a-skeleton v-if="loading" active />
      <div v-else>
        <div class="case-detail">
          <a-descriptions size="small" :column="3">
            <span slot="title">
              <span>{{ storyData.title }}</span>
              <span class="description_subtitle">#{{ storyData.key }}</span>
              <a-divider />
            </span>
            <a-descriptions-item label="状态">
              <a-badge v-if="storyData.status" :status="storyStatus[storyData.status].status" :text="storyStatus[storyData.status].label" />
            </a-descriptions-item>
            <a-descriptions-item label="类型">
              <a-badge v-if="storyData.status" :color="storyTypes[storyData.requirement_type].color" :text="storyTypes[storyData.requirement_type].label" />
            </a-descriptions-item>
            <a-descriptions-item label="优先级">{{ storyData.priority }}</a-descriptions-item>
            <a-descriptions-item label="负责人">
              <span v-if="storyData.handlers && storyData.handlers.length > 0">
                <span v-for="user in users(storyData.handlers)" :key="user.id">
                  <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                </span>
              </span>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="已评审">
              <a-tag v-if="storyData.is_review === 0" color="green">是</a-tag>
              <a-tag v-else color="blue">否</a-tag>
            </a-descriptions-item>
            <a-descriptions-item v-if="storyData.version" label="所属迭代"> {{ storyData.version.name || null }} </a-descriptions-item>
            <a-descriptions-item label="开始时间"> {{ storyData.start_time || '--' }}</a-descriptions-item>
            <a-descriptions-item label="结束时间"> {{ storyData.end_time || '--' }}</a-descriptions-item>
            <a-descriptions-item v-if="storyData.creator" label="创建人">{{ storyData.creator.nickname }} </a-descriptions-item>
            <a-descriptions-item label="创建时间"> {{ storyData.created_time }}</a-descriptions-item>
            <a-descriptions-item label="更新时间"> {{ storyData.updated_time }}</a-descriptions-item>
            <a-descriptions-item label="产品">
              <span v-if="storyData.pm && storyData.pm.length > 0">
                <span v-for="user in users(storyData.pm)" :key="user.id">
                  <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                </span>
              </span>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="运营">
              <span v-if="storyData.operators && storyData.operators.length > 0">
                <span v-for="user in users(storyData.operators)" :key="user.id">
                  <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                </span>
              </span>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="质量">
              <span v-if="storyData.qa && storyData.qa.length > 0">
                <span v-for="user in users(storyData.qa)" :key="user.id">
                  <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                </span>
              </span>
              <span v-else>--</span>
            </a-descriptions-item>
          </a-descriptions>
          <a-tabs v-model="tabsCurrent" default-active-key="1" size="small">
            <a-tab-pane key="1" tab="详细信息">
              <EditorPreview :content="storyData.description" />
            </a-tab-pane>
          </a-tabs>
        </div>
        <div style="padding-top: 2px">
          <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">需求评审</span></a-divider>
          <a-descriptions :column="3" size="small">
            <a-descriptions-item label="评审结果(上次)">
              <review-case-result-edit :disabled="true" :review-id="reviewId" :case-id="storyData.id" :result="storyData.result" />
            </a-descriptions-item>
            <a-descriptions-item label="评审时间(上次)">
              <span v-if="storyData.result !== 1">{{ storyData.reviewTime }}</span>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="评审人员(上次)">
              <span v-if="storyData.result !== 1">{{ storyData.reviewer ? storyData.reviewer.nickname : '--' }}</span>
              <span v-else>--</span>
            </a-descriptions-item>
          </a-descriptions>
          <a-textarea v-model="resultComment" placeholder="评审结果备注" :auto-size="{ minRows: 3, maxRows: 3 }" />
        </div>
        <div style="position: absolute; right: 25px; bottom: 25px">
          <a-button type="dashed" :size="size" :disabled="!hasBefore" style="margin-right: 10px" @click="onBeforeStory">
            <a-icon type="left" />
            上一条
          </a-button>
          <a-button type="dashed" :size="size" :disabled="!hasNext" style="margin-right: 10px" @click="onNextStory">
            下一条
            <a-icon type="right" />
          </a-button>
          <a-tooltip>
            <template slot="title"> 评审结果置为"已评审"并加载下一条 </template>
            <a-button class="pass-btn" :size="size" @click="onStoryReviewed"> 已评审 </a-button>
          </a-tooltip>
          <a-tooltip>
            <template slot="title"> 评审结果置为"待更新"并加载下一条 </template>
            <a-button class="fail-btn" :size="size" @click="onStoryNeedUpdate"> 待更新 </a-button>
          </a-tooltip>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { caseUpdate } from '@/api/project/case';
import EditorPreview from '@/components/EditorPreview';
import { storyStatus, storyTypes, storyPrioritys } from '@/utils/dictionary';
import { reviewStoryDetail, updateReviewItemResult } from '@/api/project/review';
import ReviewCaseResultEdit from '@/pages/project/review/components/ReviewCaseResultEdit';

const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: 60,
    customRender: (_text, _row, index) => {
      return index + 1;
    }
  },
  {
    title: '操作步骤',
    dataIndex: 'step',
    key: 'step'
  },
  {
    title: '预期结果',
    dataIndex: 'result',
    key: 'result'
  }
];
export default {
  components: { ReviewCaseResultEdit, EditorPreview },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    reviewId: {
      type: [Number, String],
      default: null
    },
    storyId: {
      type: [Number, String],
      default: null
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasBefore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      storyStatus,
      storyTypes,
      storyPrioritys,
      loading: true,
      visible: false,
      storyData: {},
      projectId: parseInt(this.$route.params.project_id) || null,
      size: 'small',
      resultComment: '',
      autoLoadNextStory: false,
      moduleData: [],
      form: {
        steps: []
      },
      rules: {
        name: [{ required: true, message: '用例名称不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        module_id: [{ required: true, message: '所属目录不能为空', trigger: 'blur' }],
        precondition: [{ required: true, message: '前置条件不能为空', trigger: 'blur' }]
      },
      modalVisible: false,
      issueId: null,
      tabsCurrent: '1'
    };
  },
  computed: {
    counts() {
      return (record, status) => {
        const p = record.progress.status;
        return p !== null && p[status] !== undefined ? p[status] : 0;
      };
    },
    progress() {
      return p => {
        let num = 0;
        let completed = 0;
        if (p === null) {
          return 0;
        }
        for (const item in p) {
          num += p[item];
          if (item === '3') {
            completed += p[item];
          }
        }
        return completed === 0 ? completed : Math.round((completed / num) * 100);
      };
    },
    users() {
      return items => {
        return items || [];
      };
    }
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        if (this.storyId !== null) {
          this.getStoryDetail();
        }
      }
    },
    storyId() {
      if (this.storyId !== null) {
        this.getStoryDetail();
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.storyId) {
            caseUpdate({ ...this.form, project_id: this.projectId, id: this.storyId })
              .then(() => {
                this.$message.success('用例修改成功');
                this.getStoryDetail();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    deleteStep(index) {
      this.form.steps.splice(index, 1);
    },

    onAddStep() {
      this.form.steps.push({ step: null, result: null });
    },

    // 数据变更的回调
    onChange(target) {
      this.$refs.form.validateField([target]);
    },
    autoLoadNextStoryChange(e) {
      this.autoLoadNextStory = e.target.checked;
    },
    // 获取需求详情
    getStoryDetail() {
      reviewStoryDetail({ project_id: this.projectId, review_id: this.reviewId, story_id: this.storyId })
        .then(res => {
          this.storyData = res.data;
          this.resultComment = res.data.resultComment;
          this.form = {
            name: this.storyData.name,
            priority: this.storyData.priority,
            module_id: this.storyData.module_id,
            precondition: this.storyData.precondition,
            description: this.storyData.description ? this.storyData.description : '',
            steps: this.storyData.steps.length > 0 ? this.storyData.steps : [{ step: null, result: null }],
            tags: this.storyData.tags.map(item => {
              return item.id;
            })
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
    onAddIssue() {
      this.modalVisible = true;
      this.issueId = null;
    },
    closeIssueModal() {
      this.$message.success('创建缺陷成功!');
      this.modalVisible = false;
    },
    onStoryReviewed() {
      this.updateReviewStoryResult(3, this.resultComment);
    },
    onStoryNeedUpdate() {
      this.updateReviewStoryResult(4, this.resultComment);
    },
    onNextStory() {
      this.$emit('next');
    },
    onBeforeStory() {
      this.$emit('before');
    },
    updateReviewStoryResult(result, description) {
      updateReviewItemResult({
        review_id: this.reviewId,
        result: result,
        item_id: this.storyId,
        description: description
      }).then(() => {
        this.$message.success('结果更新成功');
        this.$emit('next');
        // this.$emit('change');
        // if (this.autoLoadNextStory) {
        //   this.$emit('next')
        // } else {
        //   this.getStoryDetail()
        // }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.case-detail {
  overflow-y: auto;
  height: calc(~'100vh - 350px');
}

/deep/ .ant-descriptions-title {
  margin-bottom: 0px;
}

.description_subtitle {
  margin-left: 8px;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

/deep/ .drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
}

/deep/ .steps_table .ant-input {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  margin: 2px 0;
  // border-bottom: 1px solid #d9d9d9;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:focus {
  border: none;
  border-bottom: 1px solid #1890ff;
  box-shadow: none;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:hover {
  border-bottom: 1px solid #1890ff;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}

.steps_table {
  margin-bottom: 4px;
}

.pass-btn {
  color: #fff;
  background-color: #87d068;
  border-color: #87d068;
  margin-right: 10px
}

.fail-btn {
  color: #fff;
  background-color: #E95409;
  border-color: #E95409;
  margin-right: 10px
}

.block-btn {
  color: #fff;
  background-color: #BAB8B7;
  border-color: #BAB8B7;
  margin-right: 10px
}

.na-btn {
  color: #fff;
  background-color: #B24610;
  border-color: #B24610;
  margin-right: 10px
}

/deep/ .ql-container.ql-snow {
  border: none;
  background: #fafafa;
  padding: 16px
  // font-size: 14px;
}
</style>
